export var MicroApp;
(function (MicroApp) {
    /** eg: Vue router navigate */
    let NavigateMethod;
    (function (NavigateMethod) {
        NavigateMethod["Push"] = "push";
        NavigateMethod["Replace"] = "replace";
        NavigateMethod["Back"] = "back";
        NavigateMethod["Forward"] = "forward";
        NavigateMethod["Go"] = "go";
    })(NavigateMethod = MicroApp.NavigateMethod || (MicroApp.NavigateMethod = {}));
})(MicroApp || (MicroApp = {}));
